import { useState } from 'react';
import { PxwConnectorFormData, INITIAL_FORM_DATA } from './types';
import { validateStep } from './utils';
import { useConnectorTasks } from './useConnectorTasks';

export const STEP_COUNT = 6;
export type { TaskStatus } from './useConnectorTasks';

const usePxwConnectorConfig = () => {
  const [processState, setProcessState] = useState(0);
  const [formData, setFormData] = useState<PxwConnectorFormData>(INITIAL_FORM_DATA);

  const tasks = useConnectorTasks(formData, setFormData);

  const nav = {
    processState,
    goToNextStep: () => setProcessState((s) => Math.min(s + 1, STEP_COUNT - 1)),
    goToPrevStep: () => setProcessState((s) => Math.max(s - 1, 0)),
    goToStep: (index: number) => setProcessState(Math.max(0, Math.min(index, STEP_COUNT - 1))),
    restart: () => {
      setProcessState(0);
      setFormData(INITIAL_FORM_DATA);
    },
    isCurrentStepValid: () => validateStep(processState, formData),
  };

  const stateSetters = {
    setTenant: (tenant: PxwConnectorFormData['tenant']) => setFormData((prev) => ({ ...prev, tenant })),
    setVanilla: (vanilla: PxwConnectorFormData['vanilla']) => setFormData((prev) => ({ ...prev, vanilla })),
    setQuickBooks: (quickBooks: PxwConnectorFormData['quickBooks']) => setFormData((prev) => ({ ...prev, quickBooks })),
    setShipStation: (shipStation: PxwConnectorFormData['shipStation']) => setFormData((prev) => ({ ...prev, shipStation })),
    setDiagnostic: (diagnostic: PxwConnectorFormData['diagnostic']) => setFormData((prev) => ({ ...prev, diagnostic })),
  };

  return { formData, setFormData: stateSetters, nav, tasks };
};

export default usePxwConnectorConfig;
